import React from 'react';
import { Navigate, Link as RouterLink } from 'react-router-dom';
import { Center, Spinner, Box, Text, Button } from '@chakra-ui/react';
import { useAuth } from '../context/AuthContext';

const ModuleGuard: React.FC<{ moduleKey: string; children: React.ReactNode }> = ({ moduleKey, children }) => {
  const { isLoading, isAuthenticated, isAdmin, allowedModules } = useAuth();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" color="brand.500" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isAdmin) return <>{children}</>;

  const hasModuleRestrictions = Array.isArray(allowedModules) && allowedModules.length > 0;
  const canAccess = !hasModuleRestrictions || allowedModules.includes(moduleKey);

  if (!canAccess) {
    return (
      <Center h="100vh">
        <Box textAlign="center">
          <Text fontSize="xl" color="red.500" mb={2}>No access</Text>
          <Text color="gray.600" mb={4}>You don't have permission to view this module.</Text>
          <Button as={RouterLink} to="/home" colorScheme="brand">Back</Button>
        </Box>
      </Center>
    );
  }

  return <>{children}</>;
};

export default ModuleGuard;
